<template src="./index.html">
</template>
<script>
	import {getdata} from './data.js'
	import config from '../../../../../../configHttp.js'
	import minhead from '../../../../common/minHead/index.vue'
  import {getTemplate, templateExversionquery} from '../../../../../api/bbmb.js'
	import SalesTaxReport from '../../Draftgeneration/SalesTaxReport/index.vue'
	import AssetsAndLiabilities from '../../Draftgeneration/AssetsAndLiabilities/index.vue'
	import AssetsAndLiabilitiesY from '../../Draftgeneration/AssetsAndLiabilitiesY/index.vue'
	import corporateIncomeTax from '../../Draftgeneration/corporateIncomeTax/index.vue'
	import corporateIncomeTax_V2 from '../../Draftgeneration/corporateIncomeTax_V2/index.vue'
	import SmallScaleVAT from '../../Draftgeneration/SmallScaleVAT/index.vue'
	import valueAddedTax from '../../Draftgeneration/valueAddedTax/index.vue'
	import ConsolidatedStatement from '../../Draftgeneration/ConsolidatedStatement/index.vue'
	import TaxableService from '../../Draftgeneration/TaxableService/index.vue';
	import GeneralReturn from '../../Draftgeneration/GeneralReturn/index.vue';
	import GeneralReturnF from '../../Draftgeneration/GeneralReturnF/index.vue';
	import DisabilityPayment from '../../Draftgeneration/DisabilityPayment/index.vue';
	import AdditionalTax from '../../Draftgeneration/AdditionalTax/index.vue';
	import BalanceSheet from '../../Draftgeneration/BalanceSheet/index.vue';
	export default {
		name: '',
		components: {
			SalesTaxReport,
			minhead,
			AssetsAndLiabilities,
			AssetsAndLiabilitiesY,
			corporateIncomeTax,
      corporateIncomeTax_V2,
			SmallScaleVAT,
			valueAddedTax,
			ConsolidatedStatement,
			TaxableService,
			GeneralReturn,
			DisabilityPayment,
			AdditionalTax,
			BalanceSheet,
			GeneralReturnF
		},
		props: {
			ruleForm: {
				type: Object,
				default: {}
			},
		},
		data: function() {
			return {
				searchdata: getdata().searchdata,
				searchlist: getdata().searchlist,
				outlist: [],
				headData: getdata().headData,
				pagination: getdata().pagination,
				tableData: [{}],
				shaidiag: false,
				searchdiag: false,
				showbox: {
					hjbhs:false,
					yhs:false,
					zzs:false,
					cwbbybqyyzx:false,
					cwbbybqywzx:false,
					cwbbxqy:false,
					zzsxgm:false,
					qysdsA:false,
          qysdsA_V2:false,
					cztds: false,
					fcs:false,
					cwbbkjzd:false,
					cbj:false,
					whsy:false,
					tysl:false,
					tygh:false,
					tylj:false,
					ty:false,
					noty:false,
					xfs:false,
				},
				tablekey:0,
        ruleForm2: {},
				//政策和批注
				
			};
		},
		created() {
			this.templateExversionquery()
		},
		methods: {
			forbacksale(){
				this.$emit('showback',false)
				Object.keys(this.showbox).map(key => (this.showbox[key] = false));
			},
			formbdetail(taxval){
        getTemplate({
          id: taxval.id
        }).then(res => {
          this.ruleForm2 = JSON.parse(JSON.stringify(res.data.data))
          let version = this.ruleForm2.cank1;
          if (!version) {
            version = "";
          }
          this.showbox[this.ruleForm2.sbbm + version] = true
          this.$emit('showback',true)
        })
			},
			//导出列表
			fordaochu(){
				const selectval = this.$refs.tablebox.getSelectionval()
				let params = {
					downUrl: config.baseURL + "templateEx/cellInfo/save",
					typeObj: {
						toForm: false,
						fileType: "xlsx",
						failUrl:this.$winURl
					},
					params: {
						"ids": selectval.map(item => item.id),
					},
				};
				this.$downloadcommon(params);
			},
			//模板查询
			sizechange(e) {
				this.pagination.pageSize = e
				this.templateExversionquery()
			},
			currentChange(e) {
				this.pagination.pageNum = e
				this.templateExversionquery()
			},
			submitSearch() {
				this.pagination.pageNum = 1
				this.pagination.paginationkey++
				this.templateExversionquery()
			},
			templateExversionquery(){
				let params = JSON.parse(JSON.stringify(this.searchdata))
				params.current = this.pagination.pageNum
				params.size = this.pagination.pageSize
				params.reportId = this.ruleForm.shuibId
				templateExversionquery(params).then(res=>{
					this.pagination.total = res.data.data.total;
					this.tableData = res.data.data.records
				})
			},
			forback() {
				this.$emit("forback", "")
			},
			forUpdateSearch() {
				this.searchdiag = true
			},
			closeSearch() {
				this.searchdiag = false
			},
			saveChange(e) {
				this.searchdiag = false
			},
			confirmfilter(e) {
				this.headData = e.chooselist
				this.outlist = e.nochooselist
				this.shaidiag = false
			},
			closeshaidiag() {
				this.shaidiag = false
			},
			
			
		}
	};
</script>


<style scoped lang="less">
	@import url('./index.less');
</style>
